import Vue from 'vue'
import date from '~/mixins/date'
window.Vue = Vue;

window._ = require('lodash');
window.moment = require('moment');
window.Validator = require('validatorjs');
// require('gsap');

try {
  window.$ = window.jQuery = require('jquery');
  require('bootstrap');
} catch (e) {}

import Inputmask from 'inputmask';

Vue.directive('mask', {
    bind(el, binding) {
        Inputmask(binding.value).mask(el);
    }
});

import VueMq from 'vue-mq'
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: Infinity,
  }
})

window.eventBus = new Vue();
Vue.directive('resize', {
  inserted(el) { $(el).height(el.scrollHeight); },
  update(el) { $(el).height(0).height(el.scrollHeight); }
})
// Vue.directive('clear', {
//   // When the bound element is removed from the DOM...
//   unbind: function(el, binding, vnode) {
//     console.log(el,binding,vnode) 
//     // Find the elements record and clear it
//     var record = vnode.data.model.expression
//     if (record && record.startsWith('records.')) {
//       record = record.substr(8)
//       if(store)
//       store.commit('UPDATE_RECORD', { field: record, value: null })
//     }else{
//       vnode.data.model.value = null
//       console.log(this,vnode.data.model) 
//     }
//   }
// })
Vue.filter('humanDate', (dateStr) => {
  var date = moment(dateStr)
  var dateDiff = date.diff(moment())
  return moment.duration(dateDiff).humanize(true)
})
Vue.filter('dmy', (value) => {
  if (value)
    return date.methods.formatDateForDisplay(value);
})


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'
if(config.broadcast_driver=='pusher'){
  window.Pusher = require('pusher-js');
  window.Echo = new Echo({
      broadcaster: 'pusher',
      key: 'your-pusher-key',
      cluster: 'eu',
      enabledTransports: ['ws', 'wss'],
      wsHost: window.location.hostname,
      wsPort: 6001,
      wssPort: 6001,
      disableStats: true,
      encrypted: true
  });
}
